function f(e, t) {
  if (e === t)
    return !0;
  const r = Object.keys(e), s = Object.keys(t);
  if (r.length !== s.length)
    return !1;
  for (const n of r)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
export {
  f as isEqual
};
